module.exports = __webpack_public_path__ + "img/detalle-4.fcd1c3f0.png";